import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'reducers';

/**
 * Memoized selector for the CardMaintenance page component.
 * Consolidates 10 individual useSelector calls into one, reducing re-renders
 * by only recalculating when maintenanceStore or userStore change.
 */
export const selectCardMaintenancePageContext = createSelector(
  [(state: RootState) => state.maintenanceStore, (state: RootState) => state.userStore],
  (maintenanceStore, userStore) => ({
    plasticTypesListLoading: maintenanceStore.plasticTypesListLoading,
    plasticTypesList: maintenanceStore.plasticTypesList,
    // plasticTypesListResultSize is set by the success action but not in initial state; cast to number
    plasticTypesListResultSize: ((maintenanceStore as any).plasticTypesListResultSize as number) ?? 0,
    plasticType: maintenanceStore.plasticType,
    createPlasticTypeLoading: maintenanceStore.createPlasticTypeLoading,
    createPlasticTypeLoaded: maintenanceStore.createPlasticTypeLoaded,
    updatePlasticTypeLoading: maintenanceStore.updatePlasticTypeLoading,
    updatePlasticTypeLoaded: maintenanceStore.updatePlasticTypeLoaded,
    loggedInUser: userStore.loggedInUser,
    assignedAccountNumber: userStore.assignedAccountNumber,
  })
);
